import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { debounce as _debounce } from 'lodash';

import { getHeaderAndSubnavHeight } from 'utils/getHeaderHeight';

import styles from './StarryBackground.css';

const cx = classNames.bind(styles);

class StarryBackground extends React.Component {
  constructor(props) {
    super(props);
    this.timestamp = Date.now();
    this.setupStars = this.setupStars.bind(this);
    this.updateStarPosition = this.updateStarPosition.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = _debounce(this.setupStars, 200);
  }

  componentDidMount() {
    window.addEventListener(`scroll`, this.onScroll);
    window.addEventListener(`resize`, this.onResize);
    this.setupStars();
  }

  componentWillUnmount() {
    window.removeEventListener(`scroll`, this.onScroll);
    window.removeEventListener(`resize`, this.onResize);
  }

  setupStars() {
    const headerHeight = getHeaderAndSubnavHeight();
    this.containerOffset = this.container.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop - headerHeight;
    this.onScroll();
  }

  updateStarPosition() {
    const elementOffset = this.containerOffset - window.pageYOffset;
    this.smallStars.style.transform = `translate3d(0, ${-(elementOffset * (1 / 6)).toFixed(0)}px, 0)`;
    this.largeStars.style.transform = `translate3d(0, ${-(elementOffset * (1 / 4)).toFixed(0)}px, 0)`;
  }

  onScroll() {
    const stamp = Date.now();
    const isInViewport = this.container.getBoundingClientRect().top <= window.innerHeight && this.container.getBoundingClientRect().bottom >= 0;
    const isVisible = this.container.offsetHeight > 0 && !this.props.isHidden;

    // If element is viewable, update position of stars
    if (stamp - this.timestamp >= 10 && isInViewport && isVisible) {
      window.requestAnimationFrame(this.updateStarPosition);
      this.timestamp = stamp;
    }
  }

  render() {
    const containerClass = cx(`container`, {
      'container--hidden': this.props.isHidden,
      'container--bottom-fade': this.props.bottomFade,
    });

    return (
      <div
        className={containerClass}
        ref={(el) => { this.container = el; }}
      >
        <div
          className={styles[`stars--small`]}
          ref={(el) => { this.smallStars = el; }}
        />
        <div
          className={styles[`stars--large`]}
          ref={(el) => { this.largeStars = el; }}
        />
      </div>
    );
  }
}

StarryBackground.propTypes = {
  bottomFade: PropTypes.bool,
  isHidden: PropTypes.bool,
};

export default StarryBackground;
